import LeadNotificationsProvider from './LeadNotifications.provider';

export default LeadNotificationsProvider;
